var map = {
	".": 7591,
	"./": 7591,
	"./App": 9555,
	"./App.js": 9555,
	"./CardInfo": 3411,
	"./CardInfo.js": 3411,
	"./ContestInfo": 9924,
	"./ContestInfo.js": 9924,
	"./DeckSimul": 9091,
	"./DeckSimul old": 6260,
	"./DeckSimul old.js": 6260,
	"./DeckSimul.js": 9091,
	"./DeckView": 3086,
	"./DeckView.js": 3086,
	"./Home": 3769,
	"./Home.js": 3769,
	"./Menu": 9633,
	"./Menu.js": 9633,
	"./carddata": 5489,
	"./carddata old": 1269,
	"./carddata old.json": 1269,
	"./carddata.json": 5489,
	"./images/card/BS1_001.png": 1662,
	"./images/card/BS1_002.png": 5587,
	"./images/card/BS1_003.png": 7351,
	"./images/card/BS1_004.png": 8948,
	"./images/card/BS1_005.png": 744,
	"./images/card/BS1_006.png": 3517,
	"./images/card/BS1_007.png": 2406,
	"./images/card/BS1_008.png": 7723,
	"./images/card/BS1_009.png": 2326,
	"./images/card/BS1_010.png": 3714,
	"./images/card/BS1_011.png": 4598,
	"./images/card/BS1_012.png": 6993,
	"./images/card/BS1_013.png": 1685,
	"./images/card/BS1_014.png": 6935,
	"./images/card/BS1_015.png": 6358,
	"./images/card/BS1_016.png": 9038,
	"./images/card/BS1_017.png": 1759,
	"./images/card/BS1_018.png": 3516,
	"./images/card/BS1_019.png": 5638,
	"./images/card/BS1_020.png": 845,
	"./images/card/BS1_021.png": 4423,
	"./images/card/BS1_022.png": 9646,
	"./images/card/BS1_023.png": 9243,
	"./images/card/BS1_024.png": 9977,
	"./images/card/BS1_025.png": 9457,
	"./images/card/BS1_026.png": 7991,
	"./images/card/BS1_027.png": 5180,
	"./images/card/BS1_028.png": 6259,
	"./images/card/BS1_029.png": 4874,
	"./images/card/BS1_030.png": 1341,
	"./images/card/BS1_031.png": 8071,
	"./images/card/BS1_032.png": 9143,
	"./images/card/BS1_033.png": 5952,
	"./images/card/BS1_034.png": 5241,
	"./images/card/BS1_035.png": 989,
	"./images/card/BS1_036.png": 2936,
	"./images/card/BS1_037.png": 3066,
	"./images/card/BS1_038.png": 2041,
	"./images/card/BS1_039.png": 3605,
	"./images/card/BS1_040.png": 56,
	"./images/card/BS1_041.png": 1576,
	"./images/card/BS1_042.png": 834,
	"./images/card/BS1_043.png": 7837,
	"./images/card/BS1_044.png": 6652,
	"./images/card/BS1_045.png": 9295,
	"./images/card/BS1_046.png": 6870,
	"./images/card/BS1_047.png": 5911,
	"./images/card/BS1_048.png": 7174,
	"./images/card/BS1_049.png": 8617,
	"./images/card/BS1_050.png": 5936,
	"./images/card/BS1_051.png": 5109,
	"./images/card/BS1_052.png": 382,
	"./images/card/BS1_053.png": 7309,
	"./images/card/BS1_054.png": 531,
	"./images/card/BS1_055.png": 2188,
	"./images/card/BS1_056.png": 8577,
	"./images/card/BS1_057.png": 697,
	"./images/card/BS1_058.png": 6988,
	"./images/card/BS1_059.png": 2362,
	"./images/card/BS1_060.png": 8601,
	"./images/card/BS1_061.png": 6909,
	"./images/card/BS1_062.png": 8822,
	"./images/card/BS1_063.png": 8589,
	"./images/card/BS1_064.png": 4089,
	"./images/card/BS1_065.png": 6749,
	"./images/card/BS1_066.png": 9236,
	"./images/card/BS1_067.png": 3110,
	"./images/card/BS1_068.png": 993,
	"./images/card/BS1_069.png": 7456,
	"./images/card/BS1_070.png": 9521,
	"./images/card/BS1_071.png": 8504,
	"./images/card/BS1_072.png": 295,
	"./images/card/BS1_073.png": 7617,
	"./images/card/BS1_074.png": 5317,
	"./images/card/BS1_075.png": 7583,
	"./images/card/BS1_076.png": 9631,
	"./images/card/BS1_077.png": 1465,
	"./images/card/BS1_078.png": 9890,
	"./images/card/PROMO-004.png": 7960,
	"./images/card/PROMO-005.png": 5800,
	"./images/card/PROMO-006.png": 2338,
	"./images/card/PROMO_007.png": 3677,
	"./images/card/PROMO_008.png": 8603,
	"./images/card/PROMO_009.png": 1337,
	"./images/card/PROMO_010.png": 8384,
	"./images/card/PROMO_011.png": 5776,
	"./images/card/PROMO_012.png": 7504,
	"./images/card/Promo-ST3-001_ol_2023-08-31-153126_fupu.png": 965,
	"./images/card/Promo-ST3-002_ol.png": 1598,
	"./images/card/Promo-ST3-003_ol.png": 4241,
	"./images/card/ST1_01.png": 2000,
	"./images/card/ST1_02.png": 4909,
	"./images/card/ST1_03.png": 2769,
	"./images/card/ST1_04.png": 9228,
	"./images/card/ST1_05.png": 9736,
	"./images/card/ST1_06.png": 6415,
	"./images/card/ST1_07.png": 3261,
	"./images/card/ST1_08.png": 9141,
	"./images/card/ST1_09.png": 8691,
	"./images/card/ST1_10.png": 8203,
	"./images/card/ST1_11.png": 369,
	"./images/card/ST1_12.png": 8508,
	"./images/card/ST1_13.png": 1522,
	"./images/card/ST1_14.png": 3265,
	"./images/card/ST1_15.png": 7333,
	"./images/card/ST1_16.png": 2273,
	"./images/card/ST1_17.png": 8613,
	"./images/card/ST1_18.png": 8070,
	"./images/card/ST1_19.png": 916,
	"./images/card/ST1_20.png": 893,
	"./images/card/ST1_21.png": 8394,
	"./images/card/ST1_22.png": 453,
	"./images/card/ST2_01.png": 1333,
	"./images/card/ST2_02.png": 1946,
	"./images/card/ST2_03.png": 3405,
	"./images/card/ST2_04.png": 2437,
	"./images/card/ST2_05.png": 1599,
	"./images/card/ST2_06.png": 6852,
	"./images/card/ST2_07.png": 4121,
	"./images/card/ST2_08.png": 6656,
	"./images/card/ST2_09.png": 4873,
	"./images/card/ST2_10.png": 4601,
	"./images/card/ST2_11.png": 3694,
	"./images/card/ST2_12.png": 233,
	"./images/card/ST2_13.png": 3308,
	"./images/card/ST2_14.png": 6377,
	"./images/card/ST2_15.png": 9298,
	"./images/card/ST2_16.png": 9383,
	"./images/card/ST2_17.png": 8651,
	"./images/card/ST2_18.png": 405,
	"./images/card/ST2_19.png": 7879,
	"./images/card/ST2_20.png": 2182,
	"./images/card/ST2_21.png": 9715,
	"./images/card/ST2_22.png": 2541,
	"./images/card/ST3_01.png": 1105,
	"./images/card/ST3_02.png": 551,
	"./images/card/ST3_03.png": 4444,
	"./images/card/ST3_04.png": 4110,
	"./images/card/ST3_05.png": 9769,
	"./images/card/ST3_06.png": 8450,
	"./images/card/ST3_07.png": 536,
	"./images/card/ST3_08.png": 6721,
	"./images/card/ST3_09.png": 2906,
	"./images/card/ST3_10.png": 6366,
	"./images/card/ST3_11.png": 7794,
	"./images/card/ST3_12.png": 2101,
	"./images/card/ST3_13.png": 4890,
	"./images/card/ST3_14.png": 4419,
	"./images/card/ST3_15.png": 9655,
	"./images/card/ST3_16.png": 9081,
	"./images/card/ST3_17.png": 2914,
	"./images/card/ST3_18.png": 6603,
	"./images/card/ST3_19.png": 2809,
	"./images/card/ST3_20.png": 82,
	"./images/card/ST3_21.png": 3425,
	"./images/card/ST3_22.png": 387,
	"./images/card/promo_mr1.png": 5134,
	"./images/card/promo_mr2.png": 2860,
	"./images/card/promo_mr3.png": 4727,
	"./images/card/promo_wz.png": 827,
	"./images/cardtop/BS1_001.png": 8314,
	"./images/cardtop/BS1_002.png": 4783,
	"./images/cardtop/BS1_003.png": 7870,
	"./images/cardtop/BS1_004.png": 5615,
	"./images/cardtop/BS1_005.png": 1924,
	"./images/cardtop/BS1_006.png": 9588,
	"./images/cardtop/BS1_007.png": 415,
	"./images/cardtop/BS1_008.png": 8509,
	"./images/cardtop/BS1_009.png": 5382,
	"./images/cardtop/BS1_010.png": 1639,
	"./images/cardtop/BS1_011.png": 2546,
	"./images/cardtop/BS1_012.png": 8078,
	"./images/cardtop/BS1_013.png": 4908,
	"./images/cardtop/BS1_014.png": 3267,
	"./images/cardtop/BS1_015.png": 7308,
	"./images/cardtop/BS1_016.png": 8304,
	"./images/cardtop/BS1_017.png": 963,
	"./images/cardtop/BS1_018.png": 4428,
	"./images/cardtop/BS1_019.png": 1616,
	"./images/cardtop/BS1_020.png": 5545,
	"./images/cardtop/BS1_021.png": 7132,
	"./images/cardtop/BS1_022.png": 748,
	"./images/cardtop/BS1_023.png": 9215,
	"./images/cardtop/BS1_024.png": 7684,
	"./images/cardtop/BS1_025.png": 7713,
	"./images/cardtop/BS1_026.png": 4635,
	"./images/cardtop/BS1_027.png": 4303,
	"./images/cardtop/BS1_028.png": 2760,
	"./images/cardtop/BS1_029.png": 8097,
	"./images/cardtop/BS1_030.png": 8965,
	"./images/cardtop/BS1_031.png": 8362,
	"./images/cardtop/BS1_032.png": 5885,
	"./images/cardtop/BS1_033.png": 1498,
	"./images/cardtop/BS1_034.png": 3042,
	"./images/cardtop/BS1_035.png": 7350,
	"./images/cardtop/BS1_036.png": 3828,
	"./images/cardtop/BS1_037.png": 8966,
	"./images/cardtop/BS1_038.png": 3435,
	"./images/cardtop/BS1_039.png": 78,
	"./images/cardtop/BS1_040.png": 2720,
	"./images/cardtop/BS1_041.png": 5825,
	"./images/cardtop/BS1_042.png": 5756,
	"./images/cardtop/BS1_043.png": 4692,
	"./images/cardtop/BS1_044.png": 2056,
	"./images/cardtop/BS1_045.png": 5637,
	"./images/cardtop/BS1_046.png": 1870,
	"./images/cardtop/BS1_047.png": 5169,
	"./images/cardtop/BS1_048.png": 6484,
	"./images/cardtop/BS1_049.png": 9365,
	"./images/cardtop/BS1_050.png": 3729,
	"./images/cardtop/BS1_051.png": 487,
	"./images/cardtop/BS1_052.png": 2231,
	"./images/cardtop/BS1_053.png": 9370,
	"./images/cardtop/BS1_054.png": 320,
	"./images/cardtop/BS1_055.png": 9996,
	"./images/cardtop/BS1_056.png": 9494,
	"./images/cardtop/BS1_057.png": 7575,
	"./images/cardtop/BS1_058.png": 3544,
	"./images/cardtop/BS1_059.png": 3599,
	"./images/cardtop/BS1_060.png": 4621,
	"./images/cardtop/BS1_061.png": 4361,
	"./images/cardtop/BS1_062.png": 5359,
	"./images/cardtop/BS1_063.png": 4160,
	"./images/cardtop/BS1_064.png": 8263,
	"./images/cardtop/BS1_065.png": 8180,
	"./images/cardtop/BS1_066.png": 4961,
	"./images/cardtop/BS1_067.png": 2271,
	"./images/cardtop/BS1_068.png": 6511,
	"./images/cardtop/BS1_069.png": 6429,
	"./images/cardtop/BS1_070.png": 3629,
	"./images/cardtop/BS1_071.png": 5872,
	"./images/cardtop/BS1_072.png": 8188,
	"./images/cardtop/BS1_073.png": 5238,
	"./images/cardtop/BS1_074.png": 2518,
	"./images/cardtop/BS1_075.png": 4636,
	"./images/cardtop/BS1_076.png": 8327,
	"./images/cardtop/BS1_077.png": 9650,
	"./images/cardtop/BS1_078.png": 9854,
	"./images/cardtop/PROMO-004.png": 8909,
	"./images/cardtop/PROMO-005.png": 2789,
	"./images/cardtop/PROMO-006.png": 8225,
	"./images/cardtop/PROMO_007.png": 9413,
	"./images/cardtop/PROMO_008.png": 6841,
	"./images/cardtop/PROMO_009.png": 3284,
	"./images/cardtop/PROMO_010.png": 8847,
	"./images/cardtop/PROMO_011.png": 1798,
	"./images/cardtop/PROMO_012.png": 9405,
	"./images/cardtop/Promo-ST3-001_ol_2023-08-31-153126_fupu.png": 68,
	"./images/cardtop/Promo-ST3-002_ol.png": 9703,
	"./images/cardtop/Promo-ST3-003_ol.png": 9396,
	"./images/cardtop/ST1_01.png": 7403,
	"./images/cardtop/ST1_02.png": 515,
	"./images/cardtop/ST1_03.png": 2560,
	"./images/cardtop/ST1_04.png": 9444,
	"./images/cardtop/ST1_05.png": 9741,
	"./images/cardtop/ST1_06.png": 4033,
	"./images/cardtop/ST1_07.png": 7645,
	"./images/cardtop/ST1_08.png": 4145,
	"./images/cardtop/ST1_09.png": 4457,
	"./images/cardtop/ST1_10.png": 1862,
	"./images/cardtop/ST1_11.png": 2487,
	"./images/cardtop/ST1_12.png": 1539,
	"./images/cardtop/ST1_13.png": 8792,
	"./images/cardtop/ST1_14.png": 4263,
	"./images/cardtop/ST1_15.png": 2828,
	"./images/cardtop/ST1_16.png": 1061,
	"./images/cardtop/ST1_17.png": 6810,
	"./images/cardtop/ST1_18.png": 9384,
	"./images/cardtop/ST1_19.png": 127,
	"./images/cardtop/ST1_20.png": 1399,
	"./images/cardtop/ST1_21.png": 1850,
	"./images/cardtop/ST1_22.png": 23,
	"./images/cardtop/ST2_01.png": 1416,
	"./images/cardtop/ST2_02.png": 4376,
	"./images/cardtop/ST2_03.png": 9658,
	"./images/cardtop/ST2_04.png": 4787,
	"./images/cardtop/ST2_05.png": 5370,
	"./images/cardtop/ST2_06.png": 1664,
	"./images/cardtop/ST2_07.png": 7023,
	"./images/cardtop/ST2_08.png": 9572,
	"./images/cardtop/ST2_09.png": 3805,
	"./images/cardtop/ST2_10.png": 5806,
	"./images/cardtop/ST2_11.png": 6680,
	"./images/cardtop/ST2_12.png": 7739,
	"./images/cardtop/ST2_13.png": 1393,
	"./images/cardtop/ST2_14.png": 8234,
	"./images/cardtop/ST2_15.png": 6727,
	"./images/cardtop/ST2_16.png": 1348,
	"./images/cardtop/ST2_17.png": 8583,
	"./images/cardtop/ST2_18.png": 7914,
	"./images/cardtop/ST2_19.png": 2278,
	"./images/cardtop/ST2_20.png": 7986,
	"./images/cardtop/ST2_21.png": 5979,
	"./images/cardtop/ST2_22.png": 4494,
	"./images/cardtop/ST3_01.png": 5202,
	"./images/cardtop/ST3_02.png": 4852,
	"./images/cardtop/ST3_03.png": 5014,
	"./images/cardtop/ST3_04.png": 1783,
	"./images/cardtop/ST3_05.png": 7696,
	"./images/cardtop/ST3_06.png": 33,
	"./images/cardtop/ST3_07.png": 8556,
	"./images/cardtop/ST3_08.png": 3663,
	"./images/cardtop/ST3_09.png": 9507,
	"./images/cardtop/ST3_10.png": 2556,
	"./images/cardtop/ST3_11.png": 2351,
	"./images/cardtop/ST3_12.png": 5955,
	"./images/cardtop/ST3_13.png": 489,
	"./images/cardtop/ST3_14.png": 691,
	"./images/cardtop/ST3_15.png": 9550,
	"./images/cardtop/ST3_16.png": 3682,
	"./images/cardtop/ST3_17.png": 5231,
	"./images/cardtop/ST3_18.png": 8856,
	"./images/cardtop/ST3_19.png": 6408,
	"./images/cardtop/ST3_20.png": 9250,
	"./images/cardtop/ST3_21.png": 4769,
	"./images/cardtop/ST3_22.png": 2296,
	"./images/cardtop/promo_mr1.png": 4226,
	"./images/cardtop/promo_mr2.png": 2748,
	"./images/cardtop/promo_mr3.png": 6198,
	"./images/cardtop/promo_wz.png": 5181,
	"./images/green.png": 4014,
	"./images/logo192.png": 9687,
	"./images/mix.png": 9889,
	"./images/red.png": 2670,
	"./images/yellow.png": 609,
	"./index": 7591,
	"./index.css": 1174,
	"./index.js": 7591,
	"./reportWebVitals": 4013,
	"./reportWebVitals.js": 4013,
	"./sort": 5536,
	"./sort.js": 5536
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6086;